webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Search__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_List__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_List__);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'movies',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_List___default.a
  }, {
    path: '/search',
    name: 'search',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Search___default.a
  }, {
    path: '/tvplays',
    name: 'tvplays',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_List___default.a
  }]
}));

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(41)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(52),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_muse_ui_dist_muse_ui_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_muse_ui_dist_muse_ui_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_muse_ui_dist_muse_ui_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_muse_ui__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_muse_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_muse_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_clipboard2__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_clipboard2__);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_clipboard2___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_muse_ui___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_3__App___default.a);
  }
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      activeTab: 'movies'
    };
  },

  methods: {
    handleTabChange: function handleTabChange(activeTab) {
      var pathName = activeTab;
      this.activeTab = activeTab;
      if (activeTab === 'movies') {
        pathName = '/';
      }
      this.$router.push(pathName);
    }
  }
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



var MOVIE_COL = 4;

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isLoaded: false,
      movieRows: [],
      hasDataLoadErr: false,
      hasCopySuccess: false,
      hasCopyErr: false
    };
  },
  created: function created() {
    this.fetchData();
  },

  watch: {
    '$route': 'fetchData'
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/btmovie/static/' + this.$route.name + '.json').then(function (resp) {
        _this.loading = false;

        var rows = resp.data.sort(function (one, another) {
          return another.score - one.score;
        }).reduce(function (rows, item, index, items) {
          var rowIndex = ~~(index / MOVIE_COL);
          if (index % MOVIE_COL) {
            rows[rowIndex].push(item);
          } else {
            rows[rowIndex] = [item];
          }
          return rows;
        }, []);
        _this.movieRows = rows;
      }).catch(function (error) {
        if (error) {
          _this.showToast('hasDataLoadErr');
        }
      });
    },
    onCopySuccess: function onCopySuccess() {
      this.showToast('hasCopySuccess');
    },
    onCopyError: function onCopyError() {
      this.showToast('hasCopySuccess');
    },
    showToast: function showToast(field) {
      var _this2 = this;

      this[field] = true;
      if (this.toastTimer) clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(function () {
        _this2[field] = false;
      }, 2000);
    }
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search',
  data: function data() {
    return {
      msg: 'This is search page'
    };
  }
});

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 42 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(42)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(53),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cc97d45a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(40)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(51),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-083f7ac6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v(_vm._s(_vm.msg))])
},staticRenderFns: []}

/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('mu-tabs', {
    attrs: {
      "value": _vm.activeTab
    },
    on: {
      "change": _vm.handleTabChange
    }
  }, [_c('mu-tab', {
    attrs: {
      "value": "search",
      "icon": "search",
      "title": "搜索"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "movies",
      "icon": "restore",
      "title": "电影"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "tvplays",
      "icon": "favorite",
      "title": "电视剧"
    }
  })], 1), _vm._v(" "), _c('transition', [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "post"
  }, [(_vm.hasDataLoadErr) ? _c('mu-toast', {
    attrs: {
      "message": "没有找到好电影"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasCopyErr) ? _c('mu-toast', {
    attrs: {
      "message": "复制地址失败"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasCopySuccess) ? _c('mu-toast', {
    attrs: {
      "message": "复制地址成功"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLoaded) ? _c('div', {
    staticClass: "loading"
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 40
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "movies-wrapper"
  }, _vm._l((_vm.movieRows), function(cols, rowIndex) {
    return _c('mu-row', {
      key: rowIndex,
      staticClass: "movie-row",
      attrs: {
        "gutter": ""
      }
    }, _vm._l((cols), function(movie, colIndex) {
      return _c('mu-col', {
        key: colIndex,
        attrs: {
          "width": "100",
          "tablet": "50",
          "desktop": "25"
        }
      }, [_c('mu-card', [_c('mu-card-media', {
        attrs: {
          "title": movie.title,
          "subTitle": movie.type
        }
      }, [_c('img', {
        attrs: {
          "height": "500",
          "src": movie.poster
        }
      })]), _vm._v(" "), _c('mu-card-actions', [_c('mu-chip', [_vm._v(_vm._s(movie.year))]), _vm._v(" "), _c('mu-chip', [_vm._v(_vm._s(movie.tag))]), _vm._v(" "), _c('mu-chip', {
        attrs: {
          "backgroundColor": "yellow300"
        }
      }, [_vm._v(_vm._s(movie.score))]), _vm._v(" "), _c('mu-divider', {
        staticClass: "action-divider"
      }), _vm._v(" "), _c('mu-raised-button', {
        attrs: {
          "label": "原始详情页面",
          "target": "__blank",
          "a:href": "movie.link",
          "primary": ""
        }
      }), _vm._v(" "), _c('mu-raised-button', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: (movie.paths.join('\n')),
          expression: "movie.paths.join('\\n')",
          arg: "copy"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: (_vm.onCopySuccess),
          expression: "onCopySuccess",
          arg: "success"
        }, {
          name: "clipboard",
          rawName: "v-clipboard:error",
          value: (_vm.onCopyError),
          expression: "onCopyError",
          arg: "error"
        }],
        attrs: {
          "label": "复制下载地址",
          "primary": ""
        }
      })], 1)], 1)], 1)
    }))
  }))], 1)
},staticRenderFns: []}

/***/ })
],[32]);


// WEBPACK FOOTER //
// static/js/app.18aa2ff48ccb0bdf19a2.js